import {env} from './env';

// Arc queries

export const AGENTS_LIST = `AGENTS_LIST${env}`;
export const AGENTS_LIST_COUNT = `AGENTS_LIST_COUNT${env}`;
export const BUYERS_LIST = `BUYERS_LIST${env}`;
export const BUYERS_LIST_COUNT = `BUYERS_LIST_COUNT${env}`;
export const BUYERS_LOCATION = `BUYERS_LOCATION${env}`;
export const BUYERS_LOCATION_TOTAL = `BUYERS_LOCATION_TOTAL${env}`;
export const ESCROW_TRACKING = `ESCROW_TRACKING${env}`;
export const ESCROW_TRACKING_LIST = `ESCROW_TRACKING_LIST${env}`;
export const FIRMS_LIST = `FIRMS_LIST${env}`;
export const FIRMS_LIST_COUNT = `FIRMS_LIST_COUNT${env}`;
export const GET_ALL_TENANTS = `GET_ALL_TENANTS${env}`;
export const OA_AGENT_PIPELINE = `OA_AGENT_PIPELINE${env}`;
export const OLD_STRIVE_AGENT_PIPELINE = `OLD_STRIVE_AGENT_PIPELINE${env}`;
export const PROPERTIES_BY_BUYER_STATE = `PROPERTIES_BY_BUYER_STATE${env}`;
export const PROPERTY_UNDERWRITING_TENANTS = `PROPERTY_UNDERWRITING_TENANTS${env}`;
export const SELLERS_LIST = `SELLERS_LIST${env}`;
export const SELLERS_LIST_COUNT = `SELLERS_LIST_COUNT${env}`;
export const STRIVE_AGENT_PIPELINE = `STRIVE_AGENT_PIPELINE${env}`;
export const STRIVE_AGENT_PIPELINE_DETAILS = `STRIVE_AGENT_PIPELINE_DETAILS${env}`;
export const STRIVE_BUCKETS = `STRIVE_BUCKETS${env}`;
export const STRIVE_BUCKETS_DETAILS = `STRIVE_BUCKETS_DETAILS${env}`;
export const STRIVE_FEES = `STRIVE_FEES${env}`;
export const STRIVE_HISTORICAL_PIPELINE = `STRIVE_HISTORICAL_PIPELINE${env}`;
export const STRIVE_HISTORICAL_PIPELINE_SPLIT = `STRIVE_HISTORICAL_PIPELINE_SPLIT${env}`;
export const STRIVE_INVENTORY_V2 = `STRIVE_INVENTORY_V2${env}`;
export const STRIVE_PIPELINE_CLOSED = `STRIVE_PIPELINE_CLOSED${env}`;
export const STRIVE_PIPELINE_CLOSED_SPLIT = `STRIVE_PIPELINE_CLOSED_SPLIT${env}`;
export const STRIVE_PIPELINE_TRANSACTION_TYPE = `STRIVE_PIPELINE_TRANSACTION_TYPE${env}`;
export const STRIVE_PIPELINE_TRANSACTION_TYPE_SPLIT = `STRIVE_PIPELINE_TRANSACTION_TYPE_SPLIT${env}`;
export const STRIVE_PIPELINE_V2 = `STRIVE_PIPELINE_V2${env}`;
export const STRIVE_PIPELINE_V2_SPLIT = `STRIVE_PIPELINE_V2_SPLIT${env}`;
export const STRIVE_QUARTERLY_PIPELINE = `STRIVE_QUARTERLY_PIPELINE${env}`;
export const STRIVE_QUARTERLY_PIPELINE_SPLIT = `STRIVE_QUARTERLY_PIPELINE_SPLIT${env}`;
export const TENANTS_LIST = `TENANTS_LIST${env}`;
export const TENANTS_LIST_COUNT = `TENANTS_LIST_COUNT${env}`;
export const LENDERS_LIST = `LENDERS_LIST${env}`;
export const LENDERS_LIST_COUNT = `LENDERS_LIST_COUNT${env}`;
export const TEXAS_MARKET_TRANSACTIONS = `TEXAS_MARKET_TRANSACTIONS${env}`;
export const TEXAS_REGION_TRANSACTIONS = `TEXAS_REGION_TRANSACTIONS${env}`;
export const TEXAS_TOTAL_TRANSACTIONS = `TEXAS_TOTAL_TRANSACTIONS${env}`;
export const UNDERWRITING_TENANT_LIST = `UNDERWRITING_TENANT_LIST${env}`;
export const V7_PROPERTIES_LIST = `V7_PROPERTIES_LIST${env}`;
export const V7_PROPERTIES_MAP = `V7_PROPERTIES_MAP${env}`;
export const V7_PROPERTIES_STATS = `V7_PROPERTIES_STATS${env}`;
export const V7_PROPERTIES_STATS_ACTIVE = `V7_PROPERTIES_STATS_ACTIVE${env}`;
export const V7_PROPERTIES_STATS_COUNT = `V7_PROPERTIES_STATS_COUNT${env}`;
export const PROPERTY_DATA = `PROPERTY_DATA${env}`;
export const STATS_BY_STATUS = `STATS_BY_STATUS${env}`;
export const STATS_BY_TYPE = `STATS_BY_TYPE${env}`;
export const STATS_BY_BUYER_STATE = `STATS_BY_BUYER_STATE${env}`;
export const HSC_PIPELINE = `HSC_PIPELINE${env}`;
export const HSC_PIPELINE_FEES = `HSC_PIPELINE_FEES${env}`;
export const HSC_TRACKING = `HSC_TRACKING${env}`;
export const HSC_TRACKING_LIST = `HSC_TRACKING_LIST${env}`;
export const GET_PROPERTY_HISTORY = `GET_PROPERTY_HISTORY${env}`;


// Arc email queries

export const JUST_LISTED_JUST_CLOSED_PROPERTY = `JUST_LISTED_JUST_CLOSED_PROPERTY${env}`;
export const NEGOTIATION_UNDER_CONTRACT_PROPERTY = `NEGOTIATION_UNDER_CONTRACT_PROPERTY${env}`;
export const PROPERTY_DATA_DEFAULT_EMAIL = `PROPERTY_DATA_DEFAULT_EMAIL${env}`;
